
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const FeatureAccordionItem = ({ title, children, isOpen, onClick }: { title: string, children: React.ReactNode, isOpen: boolean, onClick: () => void }) => {
    return (
        <div className="border-b border-gray-300 last:border-b-0">
            <button 
                className="w-full py-6 flex justify-between items-center text-left focus:outline-none group"
                onClick={onClick}
            >
                <span className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900 group-hover:text-black transition-colors">{title}</span>
                <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-black ${isOpen ? 'rotate-180' : ''}`}>
                    <ChevronDown size={24} />
                </div>
            </button>
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="overflow-hidden"
                    >
                        <div className="pb-8 text-lg text-gray-600 leading-relaxed text-left">
                            {children}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export const SelfManagedHosting = () => {
    const [openIndex, setOpenIndex] = useState(0); 

    const items = [
        {
            title: "Rental Management",
            content: (
                <>
                    <p className="text-sm lg:text-base">Whether you're settling into a new city or listing your space for a long-term guest, coleese gives you the tools to manage everything directly.</p>
                </>
            )
        },
        {
            title: "Legal Compliance",
            content: (
                <p className="text-sm">Landlords are terrified of the PIE Act (illegal evictions). Our digital leases are <span className="font-bold text-black">CPA & PIE compliant</span>. We update them automatically when laws change, so you can't get sued for using an old template.</p>
            )
        },
        {
            title: "Automated Nudges",
            content: (
                <p className="text-sm">Our system chases the money so you don't have to. We send the invoice, the reminder, and the late notice automatically. <span className="font-bold text-black">You never have to send an awkward 'Where is my rent?' message again.</span></p>
            )
        }
    ];

    return (
        <div className="w-full">
            {items.map((item, index) => (
                <FeatureAccordionItem 
                    key={index}
                    title={item.title}
                    isOpen={openIndex === index}
                    onClick={() => {
                        if (openIndex !== index) {
                            setOpenIndex(index);
                        }
                    }}
                >
                    {item.content}
                </FeatureAccordionItem>
            ))}
        </div>
    );
};
